import { useEffect } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CardMedia from "../Media/CardMedia";
import {
  startAnalyzeContent,
  startGetAnalysisContentList,
} from "../../actions/user";
import { useDispatchApp } from "../../lib/redux";
import { getIsVideoYoutube } from "../../utils/string";

const MediaUrlItem = ({
  mediaUrlData,
  onRemove,
  onChangeData = () => {},
  onAnalysisFinished = () => {},
  disableAnalysis = false,
  itemSize = 160,
}) => {
  const dispatch = useDispatchApp();

  const isVideoYoutube = getIsVideoYoutube(mediaUrlData.url);

  const onAnalyzeContent = async (data) => {
    const isBlobUrl = data.url.includes("blob:");
    let currentData = { ...data };

    let response;

    if (isBlobUrl) {
      const uploadedUrl = data.uploadedUrl;
      if (uploadedUrl) {
        response = await dispatch(startAnalyzeContent({ url: uploadedUrl }));
      }
    } else if (data.url) {
      response = await dispatch(
        startAnalyzeContent({ url: data.url, id: data.id })
      );
    }
    if (response?.ok) {
      const analysis = response?.data?.analysis;
      currentData = {
        ...currentData,
        analysis,
      };
      onAnalysisFinished(analysis);
    }

    onChangeData({ ...currentData, isAnalyzing: false });
  };

  const getInitialData = async () => {
    let currentData = {
      ...mediaUrlData,
      isAnalyzing: true,
    };
    onChangeData(currentData);

    const hasAnalysis = currentData.analysis;
    if (hasAnalysis) {
      onChangeData({
        ...currentData,
        isAnalyzing: false,
      });
      return;
    }

    const id = mediaUrlData.id;

    if (id) {
      const response = await dispatch(startGetAnalysisContentList({ id }));
      if (response.ok) {
        onChangeData({
          ...mediaUrlData,
          isAnalyzing: false,
          analysis: response.data,
        });
        return;
      }
      onAnalyzeContent(currentData);
    } else {
      onAnalyzeContent(currentData);
    }
  };

  useEffect(() => {
    if (!disableAnalysis) {
      getInitialData();
    }
    //eslint-disable-next-line
  }, [disableAnalysis]);

  if (isVideoYoutube) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        mb: 1,
        minHeight: itemSize,
        minWidth: itemSize,
        height: itemSize,
        width: itemSize,
        position: "relative",
      }}
    >
      <CardMedia
        url={mediaUrlData.url}
        propsType={{
          controls: false,
          autoplay: true,
          muted: true,
        }}
        sxImage={{
          borderRadius: 2,
        }}
        sxVideo={{
          borderRadius: "8px",
          objectFit: "cover",
        }}
      />

      <IconButton
        onClick={onRemove}
        sx={{
          position: "absolute",
          backgroundColor: "white !important",
          right: 4,
          top: 4,
          p: 0,
          width: itemSize <= 100 ? 18 : 24,
          height: itemSize <= 100 ? 18 : 24,
        }}
      >
        <CloseIcon
          color="primary"
          sx={{
            fontSize: itemSize <= 100 ? "0.75rem" : "1rem",
          }}
        />
      </IconButton>
    </Box>
  );
};

export default MediaUrlItem;
